// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__bCfLF"};